/* istanbul ignore file */
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useFormContext } from 'framework/form';
import ContactsBreadcrumbs from 'domain/sales/contact/shared/ContactsBreadcrumbs';
import { SingleBreadcrumbItem, UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useContactUrl } from 'domain/sales/contact/contactRouting';

const UpdateContactBreadcrumbs = () => {
  const { id } = useParams<Dictionary<string>>();
  const { data = {} } = useFormContext();
  const { firstName, middleName, lastName } = data;
  const { getSingleEntityUrl } = useContactUrl();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const displayedName = useMemo(() => `${firstName} ${middleName} ${lastName}`, []);

  return (
    <ContactsBreadcrumbs>
      <SingleBreadcrumbItem link={getSingleEntityUrl(id)} entity={displayedName} />
      <UpdateBreadcrumbItem />
    </ContactsBreadcrumbs>
  );
};

export default UpdateContactBreadcrumbs;
